import {
  TicketListItem,
  TicketDetail,
  TicketFilters,
} from '../../../types/ticketInterfaces';

export type FetchStatusType = 'idle' | 'loading' | 'succeeded' | 'failed';

export interface TicketState {
  tickets: TicketListItem[];
  totalCount: number;
  currentTicket: TicketDetail | null;
  status: FetchStatusType;
  listStatus: FetchStatusType;
  error: string | null;
}

export const initialFilters: TicketFilters = {
  status: '',
  priority: '',
  assigned_to: '',
  channel: '',
  ticket_type: '',
  product: '',
  topic: '',
  search: '',
  date_from: '',
  date_to: '',
  ordering: '-created_at',
  branch: '',
};
